import API from './API.js';
import { getStorage, saveStorage, clearStorage } from './Utils.js';
import { toast } from 'vue3-toastify';
// ---------------------
import USER_RIGHT_FALSE from '@/utils/debug/user_right_false.json';
import USER_RIGHT_TRUE from '@/utils/debug/user_right_false.json';
import USER_RIGHT_CUSTOM from '@/utils/debug/user_right_custom.json';
// ---------------------


class User {
	data;
  settings;
  $root;

  constructor($root) {
    self.data = this.getDataDefault();

    let user_data_storage = getStorage('fe_user');
    let jwt = getStorage('fe_jwt');

    if (user_data_storage !== undefined && jwt !== undefined) {
      self.data = JSON.parse(user_data_storage);

      if (self.data.con_right != undefined && typeof self.data.con_right == 'string') {
        self.data.con_right = JSON.parse(self.data.con_right);
      }
      if (self.data.con_options != undefined && typeof self.data.con_options == 'string') {
        self.data.con_options = JSON.parse(self.data.con_options);
      }

      saveStorage('fe_user', self.data);
    }
  }

  can(level, right) {
    // No loged
    if(self.data.con_id == 'no_login') {
      return false;
    }

    // ADMIN
    if(self.data.cnl_id == 6 && !$root.query.hasOwnProperty('DebugNotAdmin')) {
      return true;
    }

    // Check level =-=-=
    let return_level = false;

    if (typeof level == 'object' && level.includes(self.data.cnl_id)) {
      return_level = true;
    }
    if (typeof level == 'number' && self.data.cnl_id >= level) {
      let return_level = true;
    }

    // Check right =-=-=
    let return_right = null;

    if (__DEV__) {
      if ($root.query.hasOwnProperty('DebugRightAllFalse')) {
        self.data.con_right = USER_RIGHT_FALSE;
      }
      if ($root.query.hasOwnProperty('DebugRightAllTrue')) {
        self.data.con_right = USER_RIGHT_TRUE;
      }
      if ($root.query.hasOwnProperty('DebugRightCustom')) {
        self.data.con_right = USER_RIGHT_CUSTOM;
      }
    }

    if (self.data.con_right != undefined) {
      return_right = right.split('.').reduce(
        (acc, key) => acc?.[key], self.data.con_right
      );

      if (return_right === undefined) {
        console.error(`!!!!!!!!! Right not found: ${right} !!!!!!!!!`);
        return_right = null;
      }
    }

    if (return_right !== null) {
      return_level = return_right;
    }

    return return_level || return_right;
  }

  startTimer = function () {
    setInterval(async () => {
      if (await this.isLog()) {
        this.updateInfo();
        this.ping();
      }
    }, 30000);
  }

  updateInfo = async function() {
    self.data = {
      ...this.getDataDefault(),
      ...JSON.parse(getStorage('fe_user'))
    }

    if (data.con_id == self.data.con_id) {
      let contact = await this.getContactInfos();

      self.data = {
        ...self.data,
        ...contact,
      }

      self.data.con_options = {
        ...this.getDataDefault().con_options,
        ...self.data.con_options,
        ...contact.con_options,
      }

      if (!await this.isLog()) {
        this.logout("User not loged");
        return;
      }
      let lang = self.data.con_lng;
      if (lang === undefined || lang === null || lang === "") {
        lang = navigator.language;
        // prendre que la partie avant le tiret
        if (lang.includes('-')) {
          lang = lang.split('-')[0];
        }
      }
      saveStorage('fe_lang', lang);
      saveStorage('fe_user', self.data);
    };

    BUGS.user = self.data;
  }

  getDataDefault = function() {
    return {
      cmp_active: false,
      con_active: false,
      cnl_id: -1,
      con_id: "no_login",
      cmp_id: -1,
      cmp_name: "",
      cnl_text: "",
      con_firstname: "",
      con_lastname: "",
      con_options: {
        right: {},
        mapsConfig: {
          qualityMode: 0,
          altitudeType: 0,
          hue: 0,
          gamma: 1,
          saturation: 1,
          contrast: 1,
          brightness: 1,
          customImagery: {},
          fogActive: true,
          helpDrawActive: true,
        }
      },
      con_lng: "fr",
      jwt:""
    }
  }

	getId = function() {
    return self.data.con_id;
	}

  getCnl() {
    return self.data.cnl_id;
  }

  getData = function() {
    return self.data;
  }

  getCompany = function() {
    return self.data.cmp_id;
  }

  isLog = function() {
    let jwt = getStorage('fe_jwt');

    if (
      jwt === undefined ||
      jwt === null ||
      jwt === ""
    ) {
      return false;
    }

    return true;
  }

  login = async function(log) {
    self.data = log;

    await saveStorage('fe_user', self.data);
    await saveStorage('fe_jwt', self.data.jwt);
  }

  logout = async function (raison) {
    clearStorage('fe_user');
    clearStorage('fe_jwt');

    self.data = this.getDataDefault();

    if(raison == undefined) {
      raison = "";
    }
    else if(raison = "jwt") {
      raison = `?${raison}`;
    }

    if(raison == "rc") {
      window.location.href = `${window.location.origin}/`;
      toast.error(
        $root.$e("Vous avez été déconnecté. Veuillez vous reconnecter."),
        this.$root.toastConfig
      );
    }
    else {
      window.location.href = `${window.location.origin}/${raison}`;
    }
  }

  ping = function() {
    API.put('contactping', {});
  }

  getSettingsCustomMap = function () {
    return self?.data?.con_options?.mapsConfig?.customImagery != undefined
      ? self.data.con_options.mapsConfig.customImagery
      : this.getDataDefault().con_options.mapsConfig.customImagery;
  }

  getSettingsQuality = function () {
    return self?.data?.con_options?.mapsConfig?.qualityMode != undefined
      ? self.data.con_options.mapsConfig.qualityMode
      : this.getDataDefault().con_options.mapsConfig.qualityMode;
  }

  getSettingsAltitudeType = function () {
    return self?.data?.con_options?.mapsConfig?.altitudeType != undefined
      ? self.data.con_options.mapsConfig.altitudeType
      : this.getDataDefault().con_options.mapsConfig.altitudeType;
  }

  getSettingsHue=function(){
    return self?.data?.con_options?.mapsConfig?.hue != undefined
      ? self.data.con_options.mapsConfig.hue
      : this.getDataDefault().con_options.mapsConfig.hue;
  }

  getSettingsContrast=function(){
    return self?.data?.con_options?.mapsConfig?.contrast != undefined
      ? self.data.con_options.mapsConfig.contrast
      : this.getDataDefault().con_options.mapsConfig.contrast;
  }

  getSettingsGamma=function(){
    return self?.data?.con_options?.mapsConfig?.gamma != undefined
      ? self.data.con_options.mapsConfig.gamma
      : this.getDataDefault().con_options.mapsConfig.gamma;
  }

  getSettingsBrightness=function(){
    return self?.data?.con_options?.mapsConfig?.brightness != undefined
      ? self.data.con_options.mapsConfig.brightness
      : this.getDataDefault().con_options.mapsConfig.brightness;

  }

  getSettingsSaturation=function(){
    return self?.data?.con_options?.mapsConfig?.saturation != undefined
      ? self.data.con_options.mapsConfig.saturation
      : this.getDataDefault().con_options.mapsConfig.saturation;
  }

  getSettingsFog=function(){
    return self?.data?.con_options?.mapsConfig?.fogActive != undefined
      ? self.data.con_options.mapsConfig.fogActive
      : this.getDataDefault().con_options.mapsConfig.fogActive;
  }

  getSettingsHelpDraw=function(){
    return self?.data?.con_options?.mapsConfig?.helpDrawActive != undefined
      ? self.data.con_options.mapsConfig.helpDrawActive
      : this.getDataDefault().con_options.mapsConfig.helpDrawActive;
  }

  setCustomMap = function(key, newMap){
    self.data.con_options.mapsConfig.customImagery[key]= newMap;
    this.saveSettings();
  }

  setSettinsQuality = function(quality){
    self.data.con_options.mapsConfig.qualityMode= quality;
    this.saveSettings();
  }

  setSettingsAltitude=function(altitude){
    self.data.con_options.mapsConfig.altitudeType = altitude;
    this.saveSettings();
  }

  setSettingsHue=function(hue){
    self.data.con_options.mapsConfig.hue = hue;
    this.saveSettings();
  }

  setSettingsContrast=function(contrast){
    self.data.con_options.mapsConfig.contrast = contrast;
    this.saveSettings();
  }

  setSettingsGamma=function(gamma){
    self.data.con_options.mapsConfig.gamma = gamma;
    this.saveSettings();
  }

  setSettingsBrightness=function(brightness){
    self.data.con_options.mapsConfig.brightness = brightness;
    this.saveSettings();
  }

  setSettingsSaturation=function(saturation){
    self.data.con_options.mapsConfig.saturation = saturation;
    this.saveSettings();
  }

  setSettingsFog=function(active){
    self.data.con_options.mapsConfig.fogActive = active;
    this.saveSettings();
  }

  setSettingsHelpDraw=function(active){
    self.data.con_options.mapsConfig.helpDrawActive = active;
    this.saveSettings();
  }

  setLanguage = function (lang) {
    self.data.con_lng = lang;
    saveStorage('fe_lang', lang);
    this.saveSettings();
  }

  getLanguage = function () {
    return self.data.con_lng;
  }

  removeItemCustomMap = function (key){
    delete self.data.con_options.mapsConfig.customImagery[key];
    this.saveSettings();
  }

	async saveSettings() {
    let con_id= this.getId();
    if ( con_id == 'no_login') return;

    let response = await API.put("contact", {
      con_id: con_id,
      con_options: self.data.con_options,
      con_lng: self.data.con_lng,
    });

    if (response !== undefined && response !== null && response.Result != ENV.API_RESPONSE_VALID) {
      toast.error(
        $root.$e("Erreur lors de l'enregistrement de vos nouvelles informations. ") + response,
        this.$root.toastConfig
      );
      return;
    }

    saveStorage('fe_user', self.data);
  }



  // async getSettings(){
  //   let contact = await this.getContactInfos();

  //   if (contact.con_id == self.data.con_id) {

  //     self.settings = {
  //       ...self.settings,
  //       ...contact.con_options,
  //     }
  //   }
  // }

  async getContactInfos(){
    let contact = API.getFirstData(
      await API.get(`contact`, {
        con_id: self.data.con_id
      })
    );

    return contact;
  }

  async getSitesUser(arrLevelUser, keyUserRights, allowGarage = false, $sites = false, $user = false) {
    $sites = $sites === false
      ? await API.get("site", {})
      : $sites;

    $user = $user === false
      ? this.getData()
      : $user;

    let sitesFilter = ($sites).filter(
      (site) => {
        if (site.sit_active === false) {
          return false;
        }

        let site_deleted_or_garage = allowGarage
          ? !site.sit_name.includes(ENV.DELETED)
          : site.sit_name !== ENV.DEVICE_SITE_GARAGE && !site.sit_name.includes(ENV.DELETED)

        if (this.can(arrLevelUser, keyUserRights)) {
          return site_deleted_or_garage
        }

        if ($user?.con_right?.SITES?.SITES_ALLOWED === undefined) {
          return false;
        }

        return site_deleted_or_garage && $user.con_right?.SITES?.SITES_ALLOWED.includes(site.sit_id)
      }
    )

    return sitesFilter;
  }

  getMapFilter() {
    return self.data?.con_options?.mapfilter || false;
  }

  setMapFilter(value) {
    self.data.con_options.mapfilter = value;
    this.saveSettings();
  }

  accessSite(sit_id){
    if (this.can([6, 5], 'SITES.all_allowed')) {
      return true;
    }

    let data = self.data?.con_right?.SITES?.SITES_ALLOWED || [];
    return data.includes(sit_id);
  }

  getkeysLayout(){
    return self.data?.con_options?.keysLayout || 'fr';
  }

  setkeysLayout(value){
    self.data.con_options.keysLayout = value;
    this.saveSettings();
  }

  getRamdomPassword() {
    let min = "abcdefghjkmnpqrstuvwxyz";
    let maj = "ABCDEFGHJKMNPQRSTUVWXYZ";
    let num = "123456789";
    let spe = "~#-_@=!?:!%*$";

    let string_length = 3;
    let randomstring = '';
    let min_length = 20;

    randomstring += maj.charAt(Math.floor(Math.random() * maj.length));
    randomstring += min.charAt(Math.floor(Math.random() * min.length));
    randomstring += num.charAt(Math.floor(Math.random() * num.length));
    randomstring += num.charAt(Math.floor(Math.random() * num.length));
    randomstring += maj.charAt(Math.floor(Math.random() * maj.length));
    randomstring += spe.charAt(Math.floor(Math.random() * spe.length));

    while (randomstring.length < min_length) {
      let rnum = Math.floor(Math.random() * 4);
      if (rnum == 0) {
        randomstring += maj.charAt(Math.floor(Math.random() * maj.length));
      } else if (rnum == 1) {
        randomstring += min.charAt(Math.floor(Math.random() * min.length));
      } else if (rnum == 2) {
        randomstring += num.charAt(Math.floor(Math.random() * num.length));
      } else if (rnum == 3) {
        randomstring += spe.charAt(Math.floor(Math.random() * spe.length));
      }
    }

    return randomstring;
  }

  async deleteIdUser(con_id) {
    let r = await API.put(`contact`, {
      con_id: con_id,
      con_lastname: ENV.DELETED + '_' + con_id,
      con_firstname: ENV.DELETED + '_' + con_id,
      con_email: ENV.DELETED + '_' + con_id + ENV.DELETED_EMAIL,
      con_pass: this.getRamdomPassword(),
      con_active: false,
      cnl_id: 0
    })

    return r;
  }
}

export default User;
